const surveyTypes = Object.freeze({
  DAY_OF_SAMPLING: 'DAY_OF_SAMPLING',
  MEDICAL_HISTORY: 'MEDICAL_HISTORY',
  MENTAL: 'MENTAL',
  EXERCISE: 'EXERCISE',
  FOOD: 'FOOD'
})

export default surveyTypes
